(() => {
  const publish = (name, data, attempt = 0) => {
    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish(name, data);
      return;
    }

    if (attempt < 20) {
      window.setTimeout(() => publish(name, data, attempt + 1), 200);
    }
  };

  const context = () => ({
    page_location: window.location.href,
    page_title: document.title,
    language: document.documentElement.lang || ''
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-hilite-appointment], a[href*="meetings.hubspot.com/info9920"]');
    if (!link) return;

    publish('hilite:appointment_clicked', {
      ...context(),
      link_url: link.href,
      link_text: link.textContent.trim()
    });
  });

  const contactSuccess = document.querySelector('[data-hilite-contact-success]');
  const storageKey = `hilite-contact-success:${window.location.pathname}`;

  if (contactSuccess) {
    if (!window.sessionStorage.getItem(storageKey)) {
      window.sessionStorage.setItem(storageKey, '1');
      publish('hilite:contact_submitted', context());
    }
  } else {
    window.sessionStorage.removeItem(storageKey);
  }
})();
